import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { UtilService } from '@services/util.service';
import { RequisicaoExternaService } from '../../services/requisicaoexterna.service';

@Component({
  selector: 'app-cameras',
  templateUrl: './cameras.component.html',
  styleUrls: ['./cameras.component.css'],
})

export class CamerasComponent implements AfterViewInit {
  utilService: UtilService;
  constructor(private requisicaoExternaService: RequisicaoExternaService, @Inject(DOCUMENT) public document: Document) {
  }

  ngAfterViewInit(): void {
    this.functionAtualizarRelatorioTomus();
  }

  functionAtualizarRelatorioTomus = () => {
    this.requisicaoExternaService.ObterResultado("cameras").subscribe(resultado => {
      const urlObject = URL.createObjectURL(new Blob([resultado.resultadoRequisicao], {
        type: 'text/html'
      }));

      var referenciaElementoTestado = this.document.getElementById("iframeCameras") as HTMLIFrameElement;
      referenciaElementoTestado.src = urlObject;
    });

    window.onmessage = (e) => {
      let codigo: number = +e.data.codigo;
      let bombas: number = +e.data.bombas;
      if (codigo > 0 && bombas > 0) {
        var pagina = "piscinao_detalhe/" + codigo + "_" + bombas;
        location.href = pagina;
      }
      else {
        alert('Sem informação detalhada para este registro');
      }
    };
  }
}
